<a class="digihaven-format-preview-link" [attr.href]="href()" [title]="roles().length ? ('hierarchy.preview-with-roles' | translate: { roles: roles().join(', ') }) : ('hierarchy.preview' | translate)" target="_blank" rel="noopener">
    <span class="sh-tag__label">{{ label() }}</span>
    <svg sh-icon [name]="'eye'" [size]="iconSize.SMALL" [addDefaultClasses]="false" aria-hidden="true" class="sh-tag__icon"></svg>
</a>
